import {useTranslation} from "react-i18next";
import {typeStateCategories} from "../Layout";
import {Control} from "./Control";
import TopPageSubtitle from "./TopPageSubtitle";
import TopPageTitle from "./TopPageTitle";
import ActionButton from "./ActionButton";

interface TopPageProps extends typeStateCategories {
}

export const TopPage = (props: TopPageProps) => {
	const {state} = props;
	const [category] = state;
	const {t} = useTranslation();

	return (
		<div className="toppage">
			<TopPageTitle category={category}/>
			<TopPageSubtitle category={category}/>
			<p className="text-align-center">
				<small>
					<span className="icon--ri arrow-left-line"></span>
					{t("Klicken zum Wechseln")}
					<span className="icon--ri arrow-right-line"></span>
				</small>
			</p>
			<Control state={state}/>
			<ActionButton category={category}/>
		</div>
	);
};
